document.addEventListener('DOMContentLoaded', function() {

  // Use event delegation on the document body to catch clicks on swatches
  document.body.addEventListener('click', function(e) {
    // Impulse theme uses the class 'color-swatch' but also sometimes '.swatch'.
    // We target the closest element that has the class 'color-swatch' (which is the link/span element).
    const swatch = e.target.closest('.color-swatch'); 

    // 1. Check if the clicked element is a product swatch
    if (!swatch) return;

    // 2. CRUCIAL: Prevent the default action (which is to navigate to the product page)
    e.preventDefault(); 
    e.stopPropagation(); // Stop the click from bubbling up

    // Find the parent product card
    const productCard = swatch.closest('.grid-product'); // Impulse uses .grid-product for the card container
    if (!productCard) return;

    // Find the main product image in the card
    const mainImage = productCard.querySelector('.grid-product__image-mask img');
    if (!mainImage) return;

    // Get the variant image URL from the swatch's data-attribute
    // **KEY CHANGE:** Reading data-variant-image from your Liquid
    const variantImage = swatch.dataset.variantImage || swatch.getAttribute('data-variant-image'); 
    
    if (!variantImage) return;

    // 3. Swap the image source
    mainImage.src = variantImage;
    mainImage.srcset = variantImage; // For responsiveness

    // 4. Update active swatch style
    // Ensure we are selecting swatches only within the current product card
    const swatches = productCard.querySelectorAll('.color-swatch'); 
    swatches.forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    // Optional: Force a theme refresh event
    window.dispatchEvent(new Event('resize')); 

  }, true); // Use true for the capture phase to ensure this listener runs BEFORE all others
});